@let isMobile = resizeWindowService.isMobile | async;
@let staticUrl = url | async;
@let currentItem = current | async;
@if (isMobile) {
    <button mat-button [matMenuTriggerFor]="menu">{{ currentItem?.label ?? "" | translate }}</button>
    <mat-menu #menu="matMenu" >
        @for (urlPart of staticUrl; track urlPart.key; let last = $last; let first = $first) {
            <button mat-menu-item [routerLink]="urlPart.route" [class.active]="urlPart.route != null">
                {{urlPart.label | translate}}
            </button>
        }
    </mat-menu>

} @else {
    @for (urlPart of staticUrl; track urlPart.key; let last = $last; let first = $first) {
        @if (first) {
            <a [class.last]="last" [routerLink]="urlPart.route" [class.active]="urlPart.route != null">
                <mat-icon aria-hidden="false" aria-label="Home">home</mat-icon>
            </a>
        } @else {
            <span class="separator">></span>
            <a [class.last]="last" [routerLink]="urlPart.route" [class.active]="urlPart.route != null">
                {{urlPart.label | translate}}
            </a>
        }
    }
}

